export const isLineDemoMode = process.env.REACT_APP_LINE_DEMO_MODE === "true";
